module.exports = __webpack_public_path__ + "static/media/3DPPA16.3d7bd673.jpg";